import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Si soy principiante, ¿me sirve este sistema?',
    answer: 'Sí, la biblioteca tiene patrones desde nivel 1 (principiante) hasta avanzado. Podés ir creciendo proyecto a proyecto con guías paso a paso.'
  }, {
    question: '¿Necesito materiales difíciles de conseguir en Uruguay?',
    answer: 'No. En el ebook incluimos una guía de equivalencias locales de lanas y una lista de proveedores nacionales confiables.'
  }, {
    question: '¿Puedo acceder a los patrones desde el celular?',
    answer: 'Sí. Tanto el ebook como la biblioteca de patrones son 100% digitales y accesibles desde cualquier dispositivo móvil, tablet o computadora.'
  }, {
    question: '¿El pago es único o mensual?',
    answer: 'Es un pago único. Accedés a todo el contenido de la edición 2026 de por vida, sin suscripciones mensuales.'
  }, {
    question: '¿Cómo puedo pagar? ¿Es seguro?',
    answer: 'El pago se procesa a través de Mercado Pago, una de las plataformas de cobro más seguras de Latinoamérica. Podés pagar con tarjeta de crédito, débito, transferencia bancaria o en redes de cobranza como Abitab y RedPagos. Todos tus datos están protegidos con encriptación SSL.'
  }, {
    question: '¿Puedo pagar en efectivo en Abitab o RedPagos?',
    answer: 'Sí. Al momento de pagar, Mercado Pago te da la opción de generar un cupón para abonar en efectivo en cualquier sucursal de Abitab o RedPagos de Uruguay. Una vez confirmado el pago, recibís el acceso automáticamente por email.'
  }, {
    question: '¿Cuándo recibo el producto después de pagar?',
    answer: 'La entrega es inmediata y automática. En cuanto se confirme tu pago, recibirás un email con el enlace de descarga directamente en tu casilla de correo. No tenés que esperar ni contactar a nadie.'
  }, {
    question: '¿Qué pasa si no recibo el email con el acceso?',
    answer: 'Revisá tu carpeta de spam o correo no deseado, ya que a veces los emails automáticos llegan ahí. Si aun así no lo encontrás, escribinos y te lo reenviamos de inmediato.'
  }, {
    question: '¿En qué formato viene el producto digital?',
    answer: 'El producto es un archivo PDF de alta calidad, optimizado para leer en pantalla y también para imprimir si lo preferís. No necesitás ningún programa especial, cualquier dispositivo puede abrirlo.'
  }, {
    question: '¿Puedo compartir el archivo con otras personas?',
    answer: 'El acceso es personal e intransferible. Cada compra es para uso individual. Si querés compartirlo con alguien, podés regalarle su propia copia al precio de oferta.'
  }, {
    question: '¿Tiene garantía de devolución?',
    answer: 'Sí. Ofrecemos una garantía de 7 días sin preguntas. Si por cualquier motivo no estás satisfecha con el producto, te devolvemos el 100% de tu dinero. Solo tenés que escribirnos dentro de los 7 días posteriores a la compra.'
  }];
  return <section className="py-10 md:py-24 bg-white" data-id="element-105">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-106">
        <div className="text-center mb-8 md:mb-16" data-id="element-107">
          <h2 className="text-2xl md:text-4xl font-bold text-[#3D2B1F] mb-3" data-id="element-108">
            Preguntas Frecuentes
          </h2>
          <p className="text-[#6B5A4E]" data-id="element-109">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-3" data-id="element-110">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-111" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-[#EAE0D5] rounded-xl overflow-hidden" data-id="element-112">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 md:p-6 text-left bg-[#FAF7F4] hover:bg-[#F5EBE0] transition-colors" data-id="element-113">
        <span className="font-bold text-[#3D2B1F] text-base md:text-lg" data-id="element-114">
          {question}
        </span>
        {isOpen ? <Minus className="w-5 h-5 text-[#C17B5C] flex-shrink-0" data-id="element-115" /> : <Plus className="w-5 h-5 text-[#C17B5C] flex-shrink-0" data-id="element-116" />}
      </button>
      <AnimatePresence data-id="element-117">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-118">
            <div className="p-4 md:p-6 bg-white border-t border-[#EAE0D5] text-sm md:text-base text-[#6B5A4E]" data-id="element-119">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}